<mat-card class="example-card">
  <mat-card-content>
    <mat-toolbar color="primary">Groupes catégories</mat-toolbar>
    <ng-template #attente>
      <br>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </ng-template>
    <div *ngIf="enregistrementTerminer;else attente"></div>
    <form class="example-form" #f="ngForm">
      <br>
      <div fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutGap="12px" fxLayoutAlign="flex-start">
        <div fxFlex="0 1 calc(50% - 10px)" fxFlex.lt-md="0 1 calc(36% - 10px)" fxFlex.lt-sm="100%">
          <mat-card class="example-card">
            <mat-card-header>
              <mat-card-title>Groupe</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div fxLayout="row" fxLayoutAlign="end none">
                <span style="margin-right: 20px" class="button-row">
                  <button type="button" (click)="ajouterGroupe(f)" [disabled]="disabled" class="bet_time"
                    mat-raised-button color="primary">Ajouter groupe</button>
                </span>
                <span style="margin-right: 20px" class="button-row">
                  <button type="button" (click)="modifierGroupe(f)" mat-raised-button
                    class="colorGreen">Modifier</button>
                </span>

                <span class="button-row">
                  <button [disabled]="disabledBtnSupprimerGroupe" type="button" (click)="supprimerGroupeCategorie()"
                    mat-raised-button class="colorReed">Supprimer</button>
                </span>
                <span style="margin-left: 10px;" class="button-row">
                  <button [disabled]="disabledBtnSupprimerGroupe" type="button" (click)="supprimerImage()"
                    mat-raised-button class="coloViolet">Supprimer Image</button>
                </span>
              </div>
              <div class="dysplayFlex" style="margin-top: 10px;">
                <div style="cursor: pointer" (click)="importer('input_30_30')">
                  <img id="30_30"
                    [src]="lastEvent=='upload'?imageCategorieSrc:generalService.base_url +'images/'+imageCategorieSrc"
                    width="30px" height="30px" alt="30*30" style="margin-right: 10px">

                  <input id="input_30_30" type="file" value="importer" style="display:none;"
                    (change)="onChangeImagefile2($event)">
                </div>
                <div style="width: 150px;">
                  <app-recherche recherche="ecarticleauto2" displayColumn="Art_Des" name="article"
                    placeholder="Article"></app-recherche>
                </div>

                <!-- <mat-form-field style="margin-right: 10px">
                                      <input matInput disabled="true" name="groupe_code" #groupe_code="ngModel" 
                                          [(ngModel)]="groupe.ecGroup_Code" placeholder="Code">
                                  </mat-form-field> -->
                <mat-form-field>
                  <input [disabled]="disabled" matInput name="groupe_Label" [matAutocomplete]="autoCategoriesNiveau1"
                    (input)="ongroupeValuechange($event)" [(ngModel)]="groupe.ecGroup_Label" placeholder="Catégorie"
                    #groupe_Label="ngModel" required>
                </mat-form-field>
                <mat-autocomplete #autoCategoriesNiveau1="matAutocomplete" (optionSelected)="onGroupeSelected($event)">
                  <mat-option *ngFor="let option of categories" [id]="option.categorie_id"
                    [value]="option.categorie_Text">
                    {{option.categorie_Text}}
                  </mat-option>
                </mat-autocomplete>
                <mat-form-field style="width:50px">
                  <input matInput name="groupe_Ordre" #groupe_Ordre="ngModel" required type="number"
                    [(ngModel)]="groupe.ecGroup_Ordre" placeholder="Order">
                </mat-form-field>
              </div>
              <div fxLayout="row" fxLayoutAlign="space-between none">
                <mat-form-field>
                  <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
                </mat-form-field>
              </div>
              <div class="example-table-container">
                <table id="tableCategories" mat-table [dataSource]="dataSourceGroupes" class="mat-elevation-z8">

                  <!-- <ng-container matColumnDef="ecGroup_Icone">
                                          <th mat-header-cell *matHeaderCellDef> Icon </th>
                                          <td mat-cell *matCellDef="let element">
                                              <span style="cursor: pointer" (click)="importer('input_30_30'+ element.ecGroup_Code)">                                    
                                                  <img [id]="'30_30'+ element.ecGroup_Code" [src]="element.ecGroup_Icone" width="30px" height="30px"
                                                      alt="30*30">                                    
                                                  <input [id]="'input_30_30'+ element.ecGroup_Code" type="file" value="importer" style="display:none;"
                                                      (change)="onChangeImagefile($event,'input_30_30'+ element.ecGroup_Code,element)">
                                              </span>
                                          </td>
                                      </ng-container> -->
                  <ng-container matColumnDef="ecGroup_Icone">
                    <th mat-header-cell *matHeaderCellDef> Image </th>
                    <td mat-cell *matCellDef="let element">
                      <img [id]="'30_30'+ element.ecGroup_Code"
                        [src]="element.ecGroup_Code?generalService.base_url +'images/'+element.ecGroup_Icone:''"
                        width="40px" height="50px">
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="ecGroup_Code">
                    <th mat-header-cell *matHeaderCellDef> Code </th>
                    <td mat-cell *matCellDef="let element"> {{element.ecGroup_Code}} </td>
                  </ng-container>
                  <ng-container matColumnDef="ecGroup_Label">
                    <th mat-header-cell *matHeaderCellDef> Texte </th> <!-- {{element.ecGroup_Label}} -->
                    <td mat-cell *matCellDef="let element">
                      {{element.ecGroup_Label |  textPipe : 'capitalize'}}
                      <!-- <mat-form-field style="margin-right: 10px">
                                                  <input [disabled]="disabled" matInput
                                                      [name]="'groupe_Label'+element.ecGroup_Code" [matAutocomplete]="autogroupe"
                                                      (input)="ongroupeValuechange($event)" [(ngModel)]="element.ecGroup_Label"
                                                      placeholder="Catégorie">
                                              </mat-form-field>
                                              <mat-autocomplete #autogroupe="matAutocomplete"
                                                  (optionSelected)="onGroupeTableSelected($event,element)">
                                                  <mat-option *ngFor="let option of categories" [id]="option.categorie_Code"
                                                      [value]="option.categorie_Text">
                                                      {{option.categorie_Text}}
                                                  </mat-option>
                                              </mat-autocomplete> -->
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="ecGroup_Ordre">
                    <th mat-header-cell *matHeaderCellDef> Ordre </th>
                    <td mat-cell *matCellDef="let element">
                      {{element.ecGroup_Ordre}}
                      <!-- <mat-form-field style="margin-right: 10px">
                                                  <input matInput type="number" [name]="'groupe_Ordre'+element.ecGroup_Code"
                                                      #groupe_Ordre="ngModel" required type="number"
                                                      [(ngModel)]="element.ecGroup_Ordre" placeholder="Order">
                                              </mat-form-field> -->
                    </td>

                  </ng-container>
                  <ng-container matColumnDef="ecGroup_Statut">
                    <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Affichier l'image categorie
                    </th>
                    <td mat-cell *matCellDef="let element; let i = index">
                      <mat-checkbox class="example-margin" [name]="'check'+element.ecGroup_Code" style="height: 100%;
                      display: flex;
                      justify-content: center;" [(ngModel)]="checkedStatut[i]"
                        (change)="onselectionChange($event,row)"></mat-checkbox>
                    </td>

                  </ng-container>
                  <ng-container matColumnDef="ecGroup_Pos">
                    <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Affichier liste des Images en bas
                    </th>
                    <td mat-cell *matCellDef="let element; let i = index">
                      <mat-checkbox class="example-margin" [name]="'check'+element.ecGroup_Pos" style="height: 100%;
                      display: flex;
                      justify-content: center;" [(ngModel)]="checkedPos[i]"
                        (change)="onselectionChangeCheckBox($event,row)"></mat-checkbox>
                    </td>

                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumnsGroupes;sticky: true"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsGroupes;"
                    (click)="selectRowGroupe($event,row)"></tr>
                </table>
              </div>

            </mat-card-content>
          </mat-card>
        </div>
        <div fxFlex="0 1 calc(50% - 10px)" fxFlex.lt-md="0 1 calc(36% - 10px)" fxFlex.lt-sm="100%">

          <mat-card class="example-card">
            <mat-card-header>
              <mat-card-title>Menu du groupe</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <mat-form-field style="margin-right: 10px">
                <input matInput name="menue_Label" #menue_Label="ngModel" required
                  [(ngModel)]="groupeMenue.ecGroupMenu_Label" placeholder="Texte">
              </mat-form-field>
              <mat-form-field>
                <input type="number" matInput name="menue_code" #menue_code="ngModel"
                  [(ngModel)]="groupeMenue.ecGroupMenu_Id" placeholder="Code catégorie">
              </mat-form-field>
              <span class="button-row">
                <button type="button" (click)="ajouterMenue(f)" [disabled]="disabled" class="bet_time" mat-raised-button
                  color="primary">Ajouter menu</button>
              </span>
              <div fxLayout="row">
                <app-recherche style="margin-right: 10px" recherche="ecarticleauto2" displayColumn="Art_Des"
                  name="articleName" placeholder="Article" [(ngModel)]="parentVal"></app-recherche>
                <mat-form-field style="margin-right: 10px">
                  <input matInput [name]="'Ordre_Art'" #menueTab_Label="ngModel" 
                    [(ngModel)]="ordreArticle" placeholder="Ordre">
                </mat-form-field>
                <div type="button" style="margin-right: 10px" class="button-row">
                  <button (click)="ajouterArticle()" mat-raised-button class="colorGreen">Ajouter article</button>
                </div>
                <div style="margin-right: 10px" class="button-row">
                  <button type="button" (click)="modifierArticle()" mat-raised-button class="colorGreen">Modifier
                    article</button>
                </div>

                <div class="button-row">
                  <button type="button" [disabled]="disabledBtnSupprimerArticleMenue" (click)="supprimerArticleMenue()"
                    mat-raised-button class="colorReed">Supprimer</button>
                </div>
              </div>
              <div class="example-table-container">
                <table *ngIf="showMenu" id="tableMenue" mat-table [dataSource]="dataSourceMenue"
                  class="mat-elevation-z8" multiTemplateDataRows>
                  <ng-container matColumnDef="colExp">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element">
                      <div class="button-row">
                        <button type="button" mat-icon-button color="primary">
                          <mat-icon (click)="toggleRow(element,$event)">add</mat-icon>
                        </button>
                      </div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="ecGroupMenu_Code">
                    <th mat-header-cell *matHeaderCellDef> Code </th>
                    <td mat-cell *matCellDef="let element"> {{element.ecGroupMenu_Code}} </td>
                  </ng-container>
                  <ng-container matColumnDef="ecGroupMenu_Label">
                    <th mat-header-cell *matHeaderCellDef> Texte </th> <!-- {{element.ecGroup_Label}} -->
                    <td mat-cell *matCellDef="let element">
                      <mat-form-field style="margin-right: 10px">
                        <input matInput [name]="'menueTab_Label'+element.ecGroupMenu_Code" #menueTab_Label="ngModel"
                          required [(ngModel)]="element.ecGroupMenu_Label" placeholder="Text">
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="ecGroupMenu_Id">
                    <th mat-header-cell *matHeaderCellDef>Order</th> <!-- {{element.ecGroup_Label}} -->
                    <td mat-cell *matCellDef="let element">
                      <mat-form-field style="margin-right: 10px; width: 70px;">
                        <input matInput type="number" [name]="'menueTab_Labels'+element.ecGroupMenu_Ordre"
                          #menueTab_Labelq="ngModel" [(ngModel)]="element.ecGroupMenu_Ordre" placeholder="Order">
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element">
                      <div fxLayout="row">
                        <div class="button-row">
                          <button type="button" matTooltip="Modifier" class="bet_time" mat-button color="primary"
                            (click)="modifierMenue(element,f)">
                            <mat-icon>border_color</mat-icon>
                          </button>
                        </div>
                        <div class="button-row">
                          <button type="button" matTooltip="Supprimer" class="bet_time" mat-button color="primary"
                            (click)="supprimerMenueGroupe(element)">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>
                      </div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="expandedDetail">
                    <td *matCellDef="let element" [attr.colspan]="displayedColumnsMenues.length">
                      <div>
                        <table mat-table [dataSource]="element.detail" class="mat-elevation-z8">
                          <ng-container matColumnDef="Art_Code">
                            <th mat-header-cell *matHeaderCellDef> Code </th>
                            <td mat-cell *matCellDef="let d">{{d.Art_Code}}</td>
                          </ng-container>
                          <ng-container matColumnDef="Art_Des">
                            <th mat-header-cell *matHeaderCellDef> Désignation </th>
                            <td mat-cell *matCellDef="let d">{{d.Art_Des}}</td>
                          </ng-container>
                          <ng-container matColumnDef="Art_Ord">
                            <th mat-header-cell *matHeaderCellDef> Ordre </th>
                            <td mat-cell *matCellDef="let d">
                              <mat-form-field style="margin-right: 10px; width: 70px;">
                                <input matInput type="number" [name]="'orderArticle'+d.ecGroup_Ordre+d.Art_Code"
                                  #menueTab_Labelq="ngModel" [(ngModel)]="d.ecGroup_Ordre" placeholder="Order"
                                  (focus)="onFocusOrder(d.Id,d.ecGroup_Ordre)"
                                  (blur)="onBlurOrder(d.Id,d.ecGroup_Ordre)">
                              </mat-form-field>
                            </td>
                          </ng-container>

                          <tr mat-header-row *matHeaderRowDef="displayedColumnsArticle"></tr>
                          <tr mat-row *matRowDef="let row; columns: displayedColumnsArticle;"
                            [id]="'trTableArticle'+row.Art_Code"
                            (click)="selectRowArticles($event,row,'trTableArticle'+row.Art_Code)"></tr>
                        </table>
                      </div>
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumnsMenues;sticky: true"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsMenues;"
                    [id]="'trTable'+row.ecGroupMenu_Code"
                    (click)="selectRowMenu($event,row,'trTable'+row.ecGroupMenu_Code)"
                    [class.example-expanded-row]="expandedElement === element"></tr>
                  <tr mat-row *matRowDef="let row columns: ['expandedDetail']; when: isExpansionDetailRow"
                    [@detailExpand]="row.testExpande ? 'expanded' : 'collapsed'"></tr>
                </table>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </form>
    <mat-card *ngIf="rowGroupe?.ecGroup_Code &&generalService.cuurentUser=='BIGDAR'" class="example-card">
      <mat-card-header>
        <mat-card-title><span style="color: blue">Liste images catégorie {{rowGroupe?.ecGroup_Label}} </span>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="example-button-row">
          <button matTooltip="Ajouter" style="margin-right: 10px" mat-icon-button [disabled]="buttonDisabled"
            (click)="importer2('666_450')" color="primary">
            <mat-icon>cloud_upload</mat-icon>
          </button>
          <button matTooltip="Enregistrer" mat-icon-button [disabled]="buttonDisabled" (click)="enregistrerTextImage()"
            color="primary">
            <mat-icon>save</mat-icon>
          </button>
          <button matTooltip="Supprimer" mat-icon-button [disabled]="buttonDisabled" (click)="supprimer()"
            color="primary">
            <mat-icon>delete</mat-icon>
          </button>
          <input id="input_666_450" type="file" style="display:none;"
            (change)="onChangeImagefile($event,'ajouterBannier')">
          <input id="input_modifier_666_450" type="file" style="display:none;"
            (change)="onChangeImagefile($event,'modifierBannier')">
        </div>
        <div style="display: flex;flex-wrap: wrap;gap:10px;">
          <div
            *ngFor="let img of listeImages | filterPerAnykey : ('ImmageBannerCat_'+rowGroupe.ecGroup_Code) ;let i = index">
            <img [id]="img.File_Id" class="width-img" (click)="selectImageDeatail(img.File_Id,i)"
              style="max-height: 150px; height: 150px; width:fit-content;"
              [src]="(useDataBaseToSaveImage == 1? img.File_Content : (base_url +'images/')) + img.File_Content">
          </div>
        </div>

      </mat-card-content>
    </mat-card>
  </mat-card-content>
</mat-card>
